<template>

  <!-- Quiz Submit Button -->
  <q-btn
    rounded
    :to="to"
    :loading="loading"
    :outline="disabled"
    @click="$emit('click')"
    class="quiz-submit-button block-btn ibs-mt"
    :color="disabled ? 'accent' : 'brand-gradient'">

    <div
      class="flex items-center justify-center relative-position max-width-100">

        <span
          style="top: 1px"
          class="text-white q-px-gg relative-position text-no-wrap">
          {{ title }}
        </span>

      <div
        v-if="!noArrow"
        style="top: 1px"
        class="text-h3 text-white absolute-right q-mt-none">
        >
      </div>

    </div>

  </q-btn>

</template>

<script>

  export default {
    name: 'quiz-submit-button',
    props: {
      title: {
        type: [String, Object],
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      noArrow: {
        type: Boolean,
        default: false,
      },
      to: {
        type: String,
        default: '',
      },
    },
  };

</script>

<style lang="scss">

  .quiz-submit-button {
    max-width: 100%;
    flex-wrap: nowrap;
    margin-bottom: 0;
  }

</style>
